import { Type } from '@angular/core';
import { ContentItemType } from '@libs/form/models';
import { ItemBaseComponent } from '../../models';
import { AlertComponent } from './alert';
import { MarkupComponent } from './markup';
import { PreviewComponent } from './preview';
import { SuccessComponent } from './success';

export type ContentItemComponent =
  | PreviewComponent
  | AlertComponent
  | MarkupComponent
  | SuccessComponent
  | ItemBaseComponent;

export const ContentItemsMap: Omit<Record<ContentItemType, Type<ContentItemComponent>>, 'external'> = {
  alert: AlertComponent,
  markup: MarkupComponent,
  preview: PreviewComponent,
  success: SuccessComponent,
};
